import type React from 'react';

import { Image } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';

import { Photo } from './Photo';
import type { Media as MediaProp } from './types';
import { Video } from './Video';

type MediaProps = {
	media?: MediaProp;
	shape: 'rectangle' | 'square';
};

export const Media: React.FC<MediaProps> = ({ media, shape }) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const aspectRatio = shape === 'square' ? '1/1' : '16/9';

	if (media?.type === 'photo')
		return <Photo src={media.url} processing={media.processing} aspectRatio={aspectRatio} alt="" />;

	if (media?.type === 'video')
		return <Video html={media.html} aspectRatio={aspectRatio} backgroundImage={media.url} alt="" />;

	return (
		<Image
			src={getStaticAssetUrl('/images/default-petition-darker.gif')}
			aspectRatio={shape === 'square' ? '1:1' : '16:9'}
			className="h-full bg-[#ebebeb] object-contain align-top"
			alt=""
			loading="lazy"
		/>
	);
};
